import { useMemo, useState} from 'react';
import { useGlobalSettingsContext } from 'contexts/GlobalSettingsContext';
import { BASE_SEVERITIES, ALL_SEVERITIES } from 'views/Findings/Constants'
import { useFeatureFlag } from 'contexts/FeatureFlagContext';
import _ from 'lodash';
import { useActiveUserContext } from 'contexts/ActiveUserContext';


function filterKeys(excludeSeverity, allSeverities) {
    return [...(allSeverities ? ALL_SEVERITIES : BASE_SEVERITIES)].filter(val => excludeSeverity.indexOf(val.toUpperCase()) === -1);
}

export default function useActiveSeveritiesKeys(severities = [], allSeverities = false){
    const [excludeSeverities] = useState(severities);
    const featureFlags = useFeatureFlag();
    const { sessionData } = useActiveUserContext();
    const { excludeSeverities : globalExcludeSeverities, hierarchySeverities } = useGlobalSettingsContext();

    let severitiesToExcudeFromGlobalSettings;

    if (featureFlags.HIERARCHY_SEVERITY_MAPPING) {
        // Only consider hierarchy settings if user has only one heirarchy access else consider tenant config
        if (_.isEmpty(hierarchySeverities) || _.isEmpty(sessionData?.groups) || sessionData.groups.length > 1) {
            severitiesToExcudeFromGlobalSettings = globalExcludeSeverities;
        } else {
            severitiesToExcudeFromGlobalSettings = hierarchySeverities[sessionData.groups[0]] || globalExcludeSeverities;
        }
    } else {
        severitiesToExcudeFromGlobalSettings = globalExcludeSeverities;
    }

    return useMemo(() => filterKeys([...severitiesToExcudeFromGlobalSettings,...excludeSeverities], allSeverities), [severitiesToExcudeFromGlobalSettings, excludeSeverities, allSeverities]);
}